<!-- <div class="form-inline">
<div class="form-group">
  <label class="label-regex-input">LJU;640</label>
  <input type="text" class="sem-text-box" placeholder="ccc" size="5">
  <label class="label-regex-input">-</label>
  <input type="text" class="sem-text-box" placeholder="nnnnnn" size="10">
  <label class="label-regex-input">-</label>
  <input type="text" class="sem-text-box" placeholder="ccc" size="5">
</div>
</div> -->

<div class="form-inline">
  <div class="form-group">
    <label class="museumCodeLetters segmentsDiv">{{preSegmentsText}}</label>
    @for (segment of segments; track segment; let i = $index) {
      <div class="segmentsDiv">
        @if (segment.type==2) {
          <label class="label-regex-input">{{segment.segmentValue}}</label>
        }
        @if (segment.type==1) {
          <input [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true" type="text" class="sem-text-box text-align-center" [(ngModel)]="segment.segmentValue" (ngModelChange)="inputChange($event, i)" size="{{segment.inputSize}}" maxlength="{{segment.maxLength}}" (keydown)="keyUp($event, i)" [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }">
        }
      </div>
    }
  </div>
</div>
